import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f078de4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "SearchDetail" }
const _hoisted_2 = { class: "Flex_Wrapper" }
const _hoisted_3 = { class: "Flex_Child_OneThird" }
const _hoisted_4 = { class: "SearchDetail_Contents" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "搬入日", -1))
const _hoisted_6 = { class: "SearchDetail_Contents_List" }
const _hoisted_7 = { class: "Flex_Child_OneThird" }
const _hoisted_8 = { class: "SearchDetail_Contents" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "イベント", -1))
const _hoisted_10 = { class: "SearchDetail_Contents_List" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "Flex_Child_OneThird" }
const _hoisted_13 = { class: "SearchDetail_Contents" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "取次", -1))
const _hoisted_15 = { class: "SearchDetail_Contents_List" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "Flex_Wrapper" }
const _hoisted_18 = { class: "Flex_Child_OneThird" }
const _hoisted_19 = { class: "SearchDetail_Contents" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "条件名", -1))
const _hoisted_21 = { class: "SearchDetail_Contents_List" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "Flex_Child_OneThird" }
const _hoisted_24 = { class: "SearchDetail_Contents" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "商品種別名", -1))
const _hoisted_26 = { class: "SearchDetail_Contents_List" }
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "Flex_Child_OneThird" }
const _hoisted_29 = { class: "SearchDetail_Contents" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "伝票NO", -1))
const _hoisted_31 = { class: "SearchDetail_Contents_List" }
const _hoisted_32 = { class: "Flex_Wrapper" }
const _hoisted_33 = { class: "Flex_Child_OneThird" }
const _hoisted_34 = { class: "SearchDetail_Contents" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "請求日", -1))
const _hoisted_36 = { class: "SearchDetail_Contents_List" }
const _hoisted_37 = { class: "Flex_Child_OneThird" }
const _hoisted_38 = { class: "SearchDetail_Contents" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "登録日", -1))
const _hoisted_40 = { class: "SearchDetail_Contents_List" }
const _hoisted_41 = { class: "Flex_Child_OneThird" }
const _hoisted_42 = { class: "SearchDetail_Contents" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "SearchDetail_Contents_Title" }, "商品コード", -1))
const _hoisted_44 = { class: "SearchDetail_Contents_List" }
const _hoisted_45 = ["value"]

import { reactive, ref, watch } from "vue";
import { useStore } from "vuex";
import ModalEventList from "@/components/modal/ModalEventList.vue";
import { useRoute } from "vue-router";
import ModalSyosiList from "../modal/ModalSyosiList.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchDeliverySlip',
  setup(__props, { expose: __expose }) {

const store = useStore();
const route = useRoute();

//検索項目のリスト取得
//取次(「全件」項目を追加)
const zenken = { toritugiCd: "", torihikisakiCd: "", toritugiMei: "" };
const toritugiList = [zenken, ...store.getters["constant/getToritugiList"]];
//商品種別名
const syubetuList = store.getters["constant/getSyubetuList"];
//条件名
const joukenList = store.getters["constant/getAllTorihikiList"];
// イベント
const eventList = store.getters["constant/getEventNouhinDenpyouList"];

//詳細検索項目の格納用
let searchConditions = reactive({
  fromHannyuDate: "",
  toHannyuDate: "",
  eventMei: "",
  toritugiCd: "",
  joukenKbn: "" as string | number,
  fromSeikyuuDate: "",
  toSeikyuuDate: "",
  fromTourokuDate: "",
  toTourokuDate: "",
  syubetu: "",
  denpyouNumber: "",
  syosiCd: "",
});
watch(searchConditions, () => {
  store.commit("search/setDeliverySlipState", searchConditions);
});

// 出庫履歴の伝票NOのリンク経由の場合、伝票NOを初期設定する
if (route.query.denpyoNumber !== undefined) {
  searchConditions.denpyouNumber = String(route.query.denpyoNumber);
}

//モーダル開閉---------------------------
let eventModalVisible = ref(false); // イベントモーダル
let itemModalVisible = ref(false); // 書誌検索モーダル
const showModal = (modalName: string): void => {
  if (modalName === "eventModal") {
    eventModalVisible.value = true;
  } else if (modalName === "itemModal") {
    itemModalVisible.value = true;
  }
};
const closeModal = (modalName: string): void => {
  if (modalName === "eventModal") {
    eventModalVisible.value = false;
  } else if (modalName === "itemModal") {
    itemModalVisible.value = false;
  }
};
const ref_selectEvent = (selectedValue: string): void => {
  searchConditions.eventMei = selectedValue;
};

// 書誌モーダル関連----------------------------------
// 表示用
let selectedItem = ref({
  item_name: "",
});
const ref_selectItem = (selectedValue: { title: string; syosiCd: string }) => {
  searchConditions.syosiCd = selectedValue.syosiCd;
  selectedItem.value.item_name = selectedValue.title;
};
const inputItemCd = (event: any) => {
  searchConditions.syosiCd = event.target.value;
  selectedItem.value.item_name = "";
};

// orderHeaderから条件リセットボタンが押されたときに発火
const resetConditions = () => {
  searchConditions.fromHannyuDate = "";
  searchConditions.toHannyuDate = "";
  searchConditions.eventMei = "";
  searchConditions.toritugiCd = "";
  searchConditions.joukenKbn = "";
  searchConditions.fromSeikyuuDate = "";
  searchConditions.toSeikyuuDate = "";
  searchConditions.fromTourokuDate = "";
  searchConditions.toTourokuDate = "";
  searchConditions.syubetu = "";
  searchConditions.denpyouNumber = "";
  searchConditions.syosiCd = "";
};

__expose({
  resetConditions,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(eventModalVisible))
      ? (_openBlock(), _createBlock(ModalEventList, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (closeModal('eventModal'))),
          onRef_selectEvent: ref_selectEvent
        }))
      : _createCommentVNode("", true),
    (_unref(itemModalVisible))
      ? (_openBlock(), _createBlock(ModalSyosiList, {
          key: 1,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (closeModal('itemModal'))),
          onRef_selectSyosi: ref_selectItem
        }))
      : _createCommentVNode("", true),
    _createElementVNode("ul", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchConditions).fromHannyuDate) = $event)),
                type: "date"
              }, null, 512), [
                [_vModelText, _unref(searchConditions).fromHannyuDate]
              ]),
              _createTextVNode("～"),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchConditions).toHannyuDate) = $event)),
                type: "date"
              }, null, 512), [
                [_vModelText, _unref(searchConditions).toHannyuDate]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("li", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchConditions).eventMei) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(eventList), (option, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: option,
                    key: index
                  }, _toDisplayString(option), 9, _hoisted_11))
                }), 128))
              ], 512), [
                [_vModelSelect, _unref(searchConditions).eventMei]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("li", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchConditions).toritugiCd) = $event))
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(toritugiList, (option, index) => {
                  return _createElementVNode("option", {
                    value: option.toritugiCd,
                    key: index
                  }, _toDisplayString(option.toritugiMei), 9, _hoisted_16)
                }), 64))
              ], 512), [
                [_vModelSelect, _unref(searchConditions).toritugiCd]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("li", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchConditions).joukenKbn) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(joukenList), (option, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: option.torihikiCd,
                    key: index
                  }, _toDisplayString(option.torihikiMei), 9, _hoisted_22))
                }), 128))
              ], 512), [
                [_vModelSelect, _unref(searchConditions).joukenKbn]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("li", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(searchConditions).syubetu) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(syubetuList), (option, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: option.syubetu,
                    key: index
                  }, _toDisplayString(option.syubetu), 9, _hoisted_27))
                }), 128))
              ], 512), [
                [_vModelSelect, _unref(searchConditions).syubetu]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("li", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(searchConditions).denpyouNumber) = $event))
              }, null, 512), [
                [_vModelText, _unref(searchConditions).denpyouNumber]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("li", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(searchConditions).fromSeikyuuDate) = $event)),
                type: "date"
              }, null, 512), [
                [_vModelText, _unref(searchConditions).fromSeikyuuDate]
              ]),
              _createTextVNode("～"),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(searchConditions).toSeikyuuDate) = $event)),
                type: "date"
              }, null, 512), [
                [_vModelText, _unref(searchConditions).toSeikyuuDate]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("li", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(searchConditions).fromTourokuDate) = $event)),
                type: "date"
              }, null, 512), [
                [_vModelText, _unref(searchConditions).fromTourokuDate]
              ]),
              _createTextVNode("～"),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(searchConditions).toTourokuDate) = $event)),
                type: "date"
              }, null, 512), [
                [_vModelText, _unref(searchConditions).toTourokuDate]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("li", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("input", {
                class: "SearchDetail_Input_Yellow",
                onDblclick: _cache[13] || (_cache[13] = ($event: any) => (showModal('itemModal'))),
                onInput: inputItemCd,
                value: _unref(searchConditions).syosiCd,
                type: 'number'
              }, null, 40, _hoisted_45)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})